// @core/api/endpoints/billing/get_transaction.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTransactionResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get transaction by ID
 * Retrieves an accounting transaction record. Transactions are auto-created from payment events (payment.captured, payment.refunded).
 */
export async function GetTransaction(
  id: string,
  options?: RequestOptions
): Promise<GetTransactionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/transactions/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetTransactionResponse>(requestPath, { ...requestOptions });
}
